<template>
  <div class="loginClient">
    <el-container style="margin:10px 20px 0 20px">
      <el-header style="margin-top: 10px; height: 30px; color: #ffffff"
        ><span style="font-size:30px">万宏集团食堂预约系统</span><span style="font-size:30px;margin-left: 35px;">登录名：{{userName}}</span>
        <el-button type="primary" plain @click.native="exit" style="float: right;height:44px;width:140px;font-size:20px">退出系统</el-button>

        <!-- <el-button type="primary" size="mini" style="float:right" @click="accountEdit" >修改账号</el-button> -->
      </el-header>
      <el-main>
          <el-row :gutter="12">
              <el-col :span="17">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-size:14px">当前日期：{{ nowDate }}</span>
                    <el-tag type="danger" style="float:right;font-size:15px;height:20px;line-height:20px;margin-right:10px">预约完成一定要记得退出！！！</el-tag>
            <br>
            <el-radio-group class="interval" v-model="timeInterval" style="margin-top:5px;" @change="getUserReservationByTimeInterval">
              <el-radio-button label="中餐" >预约中餐</el-radio-button>
              <el-radio-button label="晚餐" >预约晚餐</el-radio-button>
            </el-radio-group>
          </div>
            
          <div class="calendardome" style="margin-top:-15px">
            <!-- <h5>原作者版本(加了滑动切换)</h5>
      <h5-calendar lunar :touchthreshold="50"/> -->
            <calendar
              ref="calendar"
              :multi="calendar5.multi"
              :touchthreshold="50"
              :range="calendar5.range"
              :lunar="calendar5.lunar"
              :value="calendar5.value"
              :begin="calendar5.begin"
              :end="calendar5.end"
              :monthHeight="35"
              :disabled="calendar5.disabled"
              :checkMonth="calendar5.checkMonth"
              @select="calendar5.select"
              class="calendar1"
            ></calendar>
          </div>
        </el-card>
              </el-col>
          <el-col :span="2.5">
        <el-card class="box-card" >
          <div slot="header" class="clearfix">
            <span style="font-size:18px">当前时段预约：{{ userReservation.length }}</span>
          </div>
          <div
            v-for="(resevation, i) in userReservation"
            :key="i"
            class="text item"
            style="padding: 3px 0;font-size:20px"
          >
            {{ resevation.date }}
            {{ resevation.timeInterval }}
          </div>
        </el-card>
          </el-col>
          </el-row>
        <!-- <el-card class="box-card" style="margin-top: 10px">
          <div slot="header" class="clearfix">
            <span>剩余预约名额</span>
          </div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="日期" width="100">
            </el-table-column>
            <el-table-column prop="breakfast" label="早餐"> </el-table-column>
            <el-table-column prop="count" label="中餐"> </el-table-column>
            <el-table-column prop="dinner" label="晚餐"> </el-table-column>
          </el-table>
        </el-card> -->
      </el-main>
    </el-container>
  </div>
</template>

<script>
// 局部引入
import $ from "jquery";
// import H5Calendar from "vue-calendar-h5";
import calendar from "./Component/CalendarClient/calendar.vue";
export default {
  name: "App",
  components: { calendar },
  data() {
    return {
      nowDate: "",
      calendar5: {
        // display:"2017/11/2,2017/12/2",
        multi: true,
        // show:false,
        zero: true,
        begin: [], //可选开始日期
        end: [], //可选结束日期
        value: [], //默认日期
        disabled: [],
        lunar: true, //显示农历
        // events:{},
        select: (value) => {
          this.calendarSelect(value, this.calendar5.oldValue);
        },
        oldValue: [],
        checkMonth: { month: 0, flag: false },
      },
      // 表格数据
      tableData: [],
      userToken: "",
      userReservation: [],
      timeInterval:"中餐",
      userName:""
    };
  },
  activated(){
        this.init();
    },
  created: function () {
    this.userToken = window.sessionStorage.getItem("userToken");
    this.userName = window.sessionStorage.getItem("userName");
    if (!this.userToken) {
      this.$router.push("/Clientlogin");
      return;
    }
    var aDate = new Date();
    var endDate = new Date();
    endDate.setDate(endDate.getDate() + 15);
    this.calendar5.begin = [
      aDate.getFullYear(),
      aDate.getMonth() + 1,
      aDate.getDate() + 1,
    ];
    this.calendar5.end = [
      endDate.getFullYear(),
      endDate.getMonth() + 1,
      endDate.getDate(),
    ];

    this.nowDate =
      aDate.getFullYear() +
      "-" +
      (aDate.getMonth() + 1) +
      "-" +
      aDate.getDate();
    this.tableData = [];
    this.getUserReservation();
    this.getCloseDownDate();
    // this.getRemainReservation();
  },
  mounted() {
    var that = this;
    // setInterval(function () {
    //   that.getRemainReservation();
    // }, 5000);
  },
  methods: {
    init(){},
    getUserReservationByTimeInterval(){
      this.getUserReservation();
      this.getCloseDownDate();
    },
    getUserReservation(date1) {
      const loading = this.$loading();
      var that = this;
      this.axios
        .post("/Canteen/GetUserReservation", { userToken: this.userToken,timeInterval:this.timeInterval })
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              that.userReservation = response.data.data;
              that.calendar5.value = [];
              that.calendar5.oldValue = [];
              response.data.data.forEach((d) => {
                var date = d.date.split("-");
                that.calendar5.value.push([
                  parseInt(date[0]),
                  parseInt(date[1]),
                  parseInt(date[2]),
                ]);
                that.calendar5.oldValue.push([
                  parseInt(date[0]),
                  parseInt(date[1]),
                  parseInt(date[2]),
                ]);
              });
              console.log(date1);
              if (date1) {
                that.calendar5.checkMonth.flag =
                  !that.calendar5.checkMonth.flag;
                that.calendar5.checkMonth.month = parseInt(date1.split("-")[1]);
              }
            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }
          loading.close();
        });
    },
    addCanteenReservation(date) {
      console.log(date);
      const loading = this.$loading();
      var that = this;
      this.axios
        .post("/Canteen/AddCanteenReservation", {
          userToken: this.userToken,
          date: date,
          timeInterval:this.timeInterval
        })
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              that.$message.success("预约/取消预约成功！");
              that.getUserReservation(date);
            } else {
              that.$message.error(response.data.message);
              that.getUserReservation();
            }
          } else {
            that.$message.error("请检查网络设置");
          }
          loading.close();
        });
    },
    calendarSelect(value, oldValue) {
      var result = [];
      for (var i = 0; i < value.length; i++) {
        var obj = value[i];
        var num = obj[0] + obj[1] + obj[2];
        var isExist = false;
        for (var j = 0; j < oldValue.length; j++) {
          var aj = oldValue[j];
          var n = aj[0] + aj[1] + aj[2];
          if (n == num) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          result.push(obj);
        }
      }
      if (result.length > 0) {
        var month = result[0][1];
        if (parseInt(month) < 10) {
          month = "0" + month;
        }
        var day = result[0][2];
        if (parseInt(day) < 10) {
          day = "0" + day;
        }
        this.addCanteenReservation(result[0][0] + "-" + month + "-" + day);
        return;
      }

      result = [];
      for (var i = 0; i < oldValue.length; i++) {
        var obj = oldValue[i];
        var num = obj[0] + obj[1] + obj[2];
        var isExist = false;
        for (var j = 0; j < value.length; j++) {
          var aj = value[j];
          var n = aj[0] + aj[1] + aj[2];
          if (n == num) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          result.push(obj);
        }
      }
      if (result.length > 0) {
        var month = result[0][1];

        if (parseInt(month) < 10) {
          month = "0" + month;
        }
        var day = result[0][2];
        if (parseInt(day) < 10) {
          day = "0" + day;
        }
        this.addCanteenReservation(result[0][0] + "-" + month + "-" + day);
        return;
      }
    },
    getCloseDownDate() {
      var that = this;
      this.axios
        .post("/Canteen/GetCloseDownDate", {timeIntervalName:this.timeInterval})
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              that.calendar5.disabled = [];
              response.data.data.forEach((d) => {
                var date = d.date.split("-");
                that.calendar5.disabled.push([
                  parseInt(date[0]),
                  parseInt(date[1]),
                  parseInt(date[2]),
                ]);
              });
            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }
        });
    },
    getRemainReservation() {
      var that = this;
      this.axios
        .post("/Canteen/GetRemainReservation", {})
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              that.tableData = response.data.data;
            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }
        });
    },
    exit() {
      window.sessionStorage.removeItem("userToken");
      this.$router.push("/ClientLogin");
    },
  },
};
</script>
<style>
.loginClient {
  width: 100%;
  height: 100%;
  background: url(../assets/bg.png) no-repeat;
  background-size: cover;
  position: fixed;
  z-index: -10;
}

.interval .el-radio-button__inner {
font-size: 15px;
width: 200px;
}
    .calendar-client .week{

    font-size: 15px;
    }
    .calendar-client .calendar-info-client > div.month .month-inner > span{
font-size: 20px;
height: 35px;

    }
    .month-inner{
top: -30px;
    }
    .calendar-client .calendar-info-client > div.month{
        height: 40px;
    }
    .calendar-client .calendar-info-client > div.year{
        font-size: 20px;
    }
    .calendar-client td .day{
        font-size: 20px;
        height: 26px;
        max-width: 50px;
        line-height: 21px;
    }
    .calendar-client td .text{
        font-size: 10px;

    }
    .calendar-client .day1{
        height: 50px;
    }
    .calendar-client .prev{
        width: 40px;
        height: 20px;
    }
    .calendar-client .next{
        width: 40px;
        height: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ClientIndex.vue